import styled from "styled-components/macro"

export const PushUrl = styled.div`
  min-width: 55rem;
`
